import React from 'react';
import { Page } from '../Common/Components/Page';
import { UserManagementContent } from './Components/UserManagementContent';

export const UserManagement = (): React.JSX.Element => (
  <Page title="Users" accessKey={'users'} isSearchable={true}>
    <UserManagementContent />
  </Page>
);
